import React, { PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';

export type CardContentProps = PropsWithChildren<{
  className?: string;
}>;

export function CardContent({
  children,
  className,
}: CardContentProps): ReactElement {
  const classes = classNames(className);

  return (
    <div className={classes} aria-label="Card body">
      {children}
    </div>
  );
}
